import type { ReactNode } from 'react'
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'
import { reportError } from '@mfox/shared/lib/errorReporting'

function RootFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role="alert">
      <h1>Something went wrong</h1>
      <p>{error instanceof Error ? error.message : 'Unknown error'}</p>
      <button type="button" onClick={resetErrorBoundary}>
        Try again
      </button>
    </div>
  )
}

export function RootErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary
      FallbackComponent={RootFallback}
      onError={(error, info) => reportError(error, { componentStack: info.componentStack })}
    >
      {children}
    </ErrorBoundary>
  )
}
